import type { FeatureFlagHistoryEntry as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';
import * as FeatureFlagHistoryActor from './FeatureFlagHistoryActor';

/** One recorded grant or revoke of a feature flag, from the audit log. */
export type FeatureFlagHistoryEntry = {
  id: number;
  accountId: number;
  accountName: string | null;
  actor: FeatureFlagHistoryActor.FeatureFlagHistoryActor | null;
  batchId: string | null;
  changedAt: string;
  defaultScope: boolean;
  enabled: boolean;
  feature: string;
};

export const fromGql = (item: GQLItem): FeatureFlagHistoryEntry => ({
  ...take<FeatureFlagHistoryEntry, GQLItem>(item, 'id', 'accountId', 'changedAt', 'defaultScope', 'enabled', 'feature'),
  accountName: item.accountName ?? null,
  actor: item.actor ? FeatureFlagHistoryActor.fromGql(item.actor) : null,
  batchId: item.batchId ?? null,
});

export const fromGqlCollection = (items: GQLItem[]): FeatureFlagHistoryEntry[] => items.map(fromGql);
